import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComponentVisibilityService {
  showVol = false;
  showForward = false;
  showLegs = true;
  showHistoricalGraph = false;
  showPositionGrid = true;
  showStrategiesGrid = false;
  showStructuringPanel = true;

  historicalGraphArray: { componentId: number }[] = []; // theses arrays are used to hold the different component types
  forwardCurveArray: { componentId: number }[] = [];
  volatilitySurfaceArray: { componentId: number }[] = [];

  constructor() {}

  updatePositionGrid(show?: boolean) {
    if (show !== undefined) {
      this.showPositionGrid = show;
    } else {
      this.showPositionGrid = !this.showPositionGrid;
    }
  }

  updateStrategiesGridVis(show?: boolean) {
    if (show !== undefined) {
      this.showStrategiesGrid = show;
    } else {
      this.showStrategiesGrid = !this.showStrategiesGrid;
    }
  }

  updateVolVis() {
    this.addNewVolComponentToArray();
    this.showVol = !this.showVol;
  }

  updateHistoricalGraphVis() {
    this.addNewHistoricalGraphToArray();
    this.showHistoricalGraph = !this.showHistoricalGraph;
  }

  updateForwardVis() {
    this.addNewForwardCurveComponentToArray();
    this.showForward = !this.showForward;
  }

  addNewVolComponentToArray() {
    // adds a new widget into the array.
    this.volatilitySurfaceArray = [
      ...this.volatilitySurfaceArray,
      { componentId: this.volatilitySurfaceArray.length }
    ];
  }

  addNewForwardCurveComponentToArray() {
    this.forwardCurveArray = [
      ...this.forwardCurveArray,
      { componentId: this.forwardCurveArray.length }
    ];
  }

  addNewHistoricalGraphToArray() {
    this.historicalGraphArray = [
      ...this.historicalGraphArray,
      { componentId: this.historicalGraphArray.length }
    ];
  }

  removeWidget(widgetType: string, idToDelete: number) {
    // used to delete a widget from its array
    switch (widgetType) {
      case 'fwd':
        this.forwardCurveArray.splice(idToDelete, 1);
        break;
      case 'his':
        this.historicalGraphArray.splice(idToDelete, 1);
        break;
      case 'vol':
        this.volatilitySurfaceArray.splice(idToDelete, 1);
        break;
    }
  }

  updateLegsVis() {
    this.showLegs = !this.showLegs;
  }
}
